import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Size2b01934yxlz5f as Size } from '../../models/Rect.mjs';
import {
  until1jbpn0z3f8lbg as until,
  coerceIn10fbf4zn2whhq as coerceIn,
  coerceIn1xblvmyr0tby6 as coerceIn_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  SpecificElement1fm8kkyg4nw48 as SpecificElement,
  FuzzyIndex1f984se19g5yx as FuzzyIndex,
} from './RecyclerViewAnchor.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { estimateJumpAnchor3fhl00o07marf as estimateJumpAnchor } from './Recycler2.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var RecyclerViewPlacerVerticalGridClass;
function RecyclerViewPlacerVerticalGrid() {
  if (RecyclerViewPlacerVerticalGridClass === VOID) {
    class $ {
      constructor(columns, ratio, sizeDoesNotChange) {
        ratio = ratio === VOID ? null : ratio;
        sizeDoesNotChange = sizeDoesNotChange === VOID ? false : sizeDoesNotChange;
        this.edk_1 = columns;
        this.fdk_1 = ratio;
        this.gdk_1 = sizeDoesNotChange;
        this.hdk_1 = HashMap().n8();
        this.idk_1 = null;
      }
      jdk(_this__u8e3s4, cellSize) {
        var tmp0_safe_receiver = this.fdk_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = cellSize * tmp0_safe_receiver;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.hdk_1.p3(_this__u8e3s4.f94()) : tmp1_elvis_lhs;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = _this__u8e3s4.p1().ud0_1;
          if (this.gdk_1) {
            var tmp0 = this.hdk_1;
            // Inline function 'kotlin.collections.set' call
            var key = _this__u8e3s4.f94();
            tmp0.s3(key, this_0);
          }
          tmp_0 = this_0;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        return tmp_0;
      }
      kdk(_this__u8e3s4, cellSize) {
        var tmp0_safe_receiver = this.fdk_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = cellSize * tmp0_safe_receiver;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.hdk_1.p3(_this__u8e3s4.f94()) : tmp1_elvis_lhs;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = _this__u8e3s4.udg() - _this__u8e3s4.sdg();
          if (this.gdk_1) {
            var tmp0 = this.hdk_1;
            // Inline function 'kotlin.collections.set' call
            var key = _this__u8e3s4.f94();
            tmp0.s3(key, this_0);
          }
          tmp_0 = this_0;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        return tmp_0;
      }
      ldg(dataRange, anchor, previousViewport, existingCells, getNewCell, viewport, overdraw, paddingTop, paddingLeft, paddingRight, paddingBottom, gap) {
        var cellSize = (viewport.ld0_1 - viewport.jd0_1 - paddingLeft - paddingRight - (this.edk_1 - 1 | 0) * gap) / this.edk_1;
        var constrain = new (Size())(cellSize, 10000.0);
        // Inline function 'kotlin.collections.map' call
        var this_0 = until(0, this.edk_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var inductionVariable = this_0.i2_1;
        var last = this_0.j2_1;
        if (inductionVariable <= last)
          do {
            var item = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var it = item;
            var tmp$ret$0 = paddingTop + it * gap + it * cellSize;
            destination.v(tmp$ret$0);
          }
           while (!(item === last));
        var cellOffsets = destination;
        var tmp;
        if (anchor == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0;
          if (anchor instanceof FuzzyIndex()) {
            // Inline function 'kotlin.collections.sumOf' call
            var sum = 0;
            var _iterator__ex2g4s = existingCells.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_1 = sum;
              sum = tmp_1 + this.kdk(element, cellSize);
            }
            var averageRowHeight = sum / existingCells.p1();
            var focusRowIndex = imul(numberToInt(coerceIn_0(anchor.ydj_1, dataRange.i2_1, dataRange.j2_1) / this.edk_1), this.edk_1);
            var partialIndexOffset = anchor.ydj_1 % this.edk_1 / this.edk_1 * averageRowHeight;
            tmp_0 = to(viewport.kd0_1 + (viewport.od0() - paddingTop - paddingBottom) * anchor.zdj_1 - partialIndexOffset, focusRowIndex);
          } else {
            if (anchor instanceof SpecificElement()) {
              var currentIndex = imul(coerceIn(anchor.wdj_1, dataRange) / this.edk_1 | 0, this.edk_1);
              // Inline function 'kotlin.collections.map' call
              var this_1 = until(0, this.edk_1);
              // Inline function 'kotlin.collections.mapTo' call
              var destination_0 = ArrayList().u(collectionSizeOrDefault(this_1, 10));
              var inductionVariable_0 = this_1.i2_1;
              var last_0 = this_1.j2_1;
              if (inductionVariable_0 <= last_0)
                do {
                  var item_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var it_0 = item_0;
                  var tmp_2;
                  var containsLower = dataRange.i2_1;
                  var containsUpper = dataRange.j2_1;
                  var containsArg = currentIndex + it_0 | 0;
                  if (containsLower <= containsArg ? containsArg <= containsUpper : false) {
                    tmp_2 = getNewCell(currentIndex + it_0 | 0, constrain);
                  } else {
                    tmp_2 = null;
                  }
                  var tmp$ret$5 = tmp_2;
                  destination_0.v(tmp$ret$5);
                }
                 while (!(item_0 === last_0));
              var cells = destination_0;
              // Inline function 'kotlin.collections.maxOf' call
              var iterator = cells.m1();
              if (!iterator.n1())
                throw NoSuchElementException().y1();
              var tmp0_safe_receiver = iterator.o1();
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.jdk(tmp0_safe_receiver, cellSize);
              var maxValue = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
              while (iterator.n1()) {
                var tmp0_safe_receiver_0 = iterator.o1();
                var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : this.jdk(tmp0_safe_receiver_0, cellSize);
                var v = tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0;
                // Inline function 'kotlin.comparisons.maxOf' call
                var a = maxValue;
                maxValue = Math.max(a, v);
              }
              var max = maxValue;
              var tmp0 = anchor.xdj_1.b4_1;
              tmp_0 = to(tmp0 === 0 ? viewport.kd0_1 + paddingTop : tmp0 === 2 ? viewport.md0_1 - max - paddingBottom : viewport.qd0() - max / 2, currentIndex);
            } else {
              noWhenBranchMatchedException();
            }
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs_1 = tmp;
        var tmp_3;
        if (tmp1_elvis_lhs_1 == null) {
          var tmp0_0 = asSequence(existingCells);
          var tmp$ret$14;
          $l$block_0: {
            // Inline function 'kotlin.sequences.minByOrNull' call
            var iterator_0 = tmp0_0.m1();
            if (!iterator_0.n1()) {
              tmp$ret$14 = null;
              break $l$block_0;
            }
            var minElem = iterator_0.o1();
            if (!iterator_0.n1()) {
              tmp$ret$14 = minElem;
              break $l$block_0;
            }
            var it_1 = minElem;
            var tmp_4 = it_1.pd0();
            // Inline function 'kotlin.math.abs' call
            var x = viewport.kd0_1 - it_1.sdg();
            var minValue = tmp_4 + Math.abs(x) + (it_1.sdg() <= overdraw.kd0_1 ? 10000 : 0);
            do {
              var e = iterator_0.o1();
              var tmp_5 = e.pd0();
              // Inline function 'kotlin.math.abs' call
              var x_0 = viewport.kd0_1 - e.sdg();
              var v_0 = tmp_5 + Math.abs(x_0) + (e.sdg() <= overdraw.kd0_1 ? 10000 : 0);
              if (compareTo(minValue, v_0) > 0) {
                minElem = e;
                minValue = v_0;
              }
            }
             while (iterator_0.n1());
            tmp$ret$14 = minElem;
          }
          var tmp2_safe_receiver = tmp$ret$14;
          var tmp_6;
          if (tmp2_safe_receiver == null) {
            tmp_6 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_1 = this.idk_1;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              tmp0_safe_receiver_1.fcv(['Using existing cells for anchor: ' + tmp2_safe_receiver.sdg() + ' to ' + tmp2_safe_receiver.las() + ' => ' + imul(tmp2_safe_receiver.las() / this.edk_1 | 0, this.edk_1)]);
            }
            tmp_6 = to(tmp2_safe_receiver.sdg(), imul(tmp2_safe_receiver.las() / this.edk_1 | 0, this.edk_1));
          }
          tmp_3 = tmp_6;
        } else {
          tmp_3 = tmp1_elvis_lhs_1;
        }
        var tmp3_elvis_lhs = tmp_3;
        var tmp_7;
        if (tmp3_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp$ret$21;
          $l$block_1: {
            var tmp0_elvis_lhs = estimateJumpAnchor(existingCells, true, viewport);
            var tmp_8;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$21 = null;
              break $l$block_1;
            } else {
              tmp_8 = tmp0_elvis_lhs;
            }
            var it_2 = tmp_8;
            var tmp1_safe_receiver = this.idk_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.fcv(['estimateJumpAnchor got ' + it_2.toString()]);
            }
            // Inline function 'kotlin.collections.sumOf' call
            var sum_0 = 0;
            var _iterator__ex2g4s_0 = existingCells.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              var tmp_9 = sum_0;
              sum_0 = tmp_9 + this.jdk(element_0, cellSize);
            }
            var averageRowHeight_0 = sum_0 / existingCells.p1();
            var focusRowIndex_0 = imul(numberToInt(coerceIn_0(it_2.ydj_1, dataRange.i2_1, dataRange.j2_1) / this.edk_1), this.edk_1);
            var partialIndexOffset_0 = it_2.ydj_1 % this.edk_1 / this.edk_1 * averageRowHeight_0;
            tmp$ret$21 = to(viewport.kd0_1 + viewport.od0() * it_2.zdj_1 - partialIndexOffset_0, focusRowIndex_0);
          }
          tmp_7 = tmp$ret$21;
        } else {
          tmp_7 = tmp3_elvis_lhs;
        }
        var tmp4_elvis_lhs = tmp_7;
        var tmp_10;
        if (tmp4_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var tmp0_safe_receiver_2 = this.idk_1;
          if (tmp0_safe_receiver_2 == null)
            null;
          else {
            tmp0_safe_receiver_2.fcv(['estimateJumpAnchor was dumped; no existin cells?']);
          }
          tmp_10 = to(viewport.kd0_1 + paddingTop, imul(dataRange.i2_1 / this.edk_1 | 0, this.edk_1));
        } else {
          tmp_10 = tmp4_elvis_lhs;
        }
        // Inline function 'kotlin.let' call
        var it_3 = tmp_10;
        var tmp_11;
        if (it_3.bf_1 < (dataRange.i2_1 - this.edk_1 | 0)) {
          var tmp0_safe_receiver_3 = this.idk_1;
          if (tmp0_safe_receiver_3 == null)
            null;
          else {
            tmp0_safe_receiver_3.fcv(['Anchor ignored due to out-of-range']);
          }
          tmp_11 = to(viewport.kd0_1 + paddingTop, imul(dataRange.i2_1 / this.edk_1 | 0, this.edk_1));
        } else if (it_3.bf_1 > (dataRange.j2_1 + this.edk_1 | 0)) {
          var tmp1_safe_receiver_0 = this.idk_1;
          if (tmp1_safe_receiver_0 == null)
            null;
          else {
            tmp1_safe_receiver_0.fcv(['Anchor ignored due to out-of-range']);
          }
          var currentIndex_0 = imul(dataRange.j2_1 / this.edk_1 | 0, this.edk_1);
          // Inline function 'kotlin.collections.map' call
          var this_2 = until(0, this.edk_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_1 = ArrayList().u(collectionSizeOrDefault(this_2, 10));
          var inductionVariable_1 = this_2.i2_1;
          var last_1 = this_2.j2_1;
          if (inductionVariable_1 <= last_1)
            do {
              var item_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var it_4 = item_1;
              var tmp_12;
              var containsLower_0 = dataRange.i2_1;
              var containsUpper_0 = dataRange.j2_1;
              var containsArg_0 = currentIndex_0 + it_4 | 0;
              if (containsLower_0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false) {
                tmp_12 = getNewCell(currentIndex_0 + it_4 | 0, constrain);
              } else {
                tmp_12 = null;
              }
              var tmp$ret$27 = tmp_12;
              destination_1.v(tmp$ret$27);
            }
             while (!(item_1 === last_1));
          var cells_0 = destination_1;
          // Inline function 'kotlin.collections.maxOf' call
          var iterator_1 = cells_0.m1();
          if (!iterator_1.n1())
            throw NoSuchElementException().y1();
          var tmp0_safe_receiver_4 = iterator_1.o1();
          var tmp1_elvis_lhs_2 = tmp0_safe_receiver_4 == null ? null : this.jdk(tmp0_safe_receiver_4, cellSize);
          var maxValue_0 = tmp1_elvis_lhs_2 == null ? 0.0 : tmp1_elvis_lhs_2;
          while (iterator_1.n1()) {
            var tmp0_safe_receiver_5 = iterator_1.o1();
            var tmp1_elvis_lhs_3 = tmp0_safe_receiver_5 == null ? null : this.jdk(tmp0_safe_receiver_5, cellSize);
            var v_1 = tmp1_elvis_lhs_3 == null ? 0.0 : tmp1_elvis_lhs_3;
            // Inline function 'kotlin.comparisons.maxOf' call
            var a_0 = maxValue_0;
            maxValue_0 = Math.max(a_0, v_1);
          }
          var max_0 = maxValue_0;
          tmp_11 = to(viewport.md0_1 - max_0 - paddingBottom, currentIndex_0);
        } else {
          tmp_11 = it_3;
        }
        var _destruct__k2r9zo = tmp_11;
        var anchorRowY = _destruct__k2r9zo.cf();
        var anchorRowIndex = _destruct__k2r9zo.df();
        var tmp5_safe_receiver = this.idk_1;
        if (tmp5_safe_receiver == null)
          null;
        else {
          tmp5_safe_receiver.fcv(['ANCHOR ' + anchorRowY + ' gets index ' + anchorRowIndex]);
        }
        var currentY = anchorRowY;
        var currentIndex_1 = anchorRowIndex;
        while (currentY < overdraw.md0_1 && currentIndex_1 <= dataRange.j2_1) {
          // Inline function 'kotlin.collections.map' call
          var this_3 = until(0, this.edk_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_2 = ArrayList().u(collectionSizeOrDefault(this_3, 10));
          var inductionVariable_2 = this_3.i2_1;
          var last_2 = this_3.j2_1;
          if (inductionVariable_2 <= last_2)
            do {
              var item_2 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var it_5 = item_2;
              var tmp_13;
              var containsLower_1 = dataRange.i2_1;
              var containsUpper_1 = dataRange.j2_1;
              var containsArg_1 = currentIndex_1 + it_5 | 0;
              if (containsLower_1 <= containsArg_1 ? containsArg_1 <= containsUpper_1 : false) {
                tmp_13 = getNewCell(currentIndex_1 + it_5 | 0, constrain);
              } else {
                tmp_13 = null;
              }
              var tmp$ret$36 = tmp_13;
              destination_2.v(tmp$ret$36);
            }
             while (!(item_2 === last_2));
          var cells_1 = destination_2;
          // Inline function 'kotlin.collections.maxOf' call
          var iterator_2 = cells_1.m1();
          if (!iterator_2.n1())
            throw NoSuchElementException().y1();
          var tmp0_safe_receiver_6 = iterator_2.o1();
          var tmp1_elvis_lhs_4 = tmp0_safe_receiver_6 == null ? null : this.jdk(tmp0_safe_receiver_6, cellSize);
          var maxValue_1 = tmp1_elvis_lhs_4 == null ? 0.0 : tmp1_elvis_lhs_4;
          while (iterator_2.n1()) {
            var tmp0_safe_receiver_7 = iterator_2.o1();
            var tmp1_elvis_lhs_5 = tmp0_safe_receiver_7 == null ? null : this.jdk(tmp0_safe_receiver_7, cellSize);
            var v_2 = tmp1_elvis_lhs_5 == null ? 0.0 : tmp1_elvis_lhs_5;
            // Inline function 'kotlin.comparisons.maxOf' call
            var a_1 = maxValue_1;
            maxValue_1 = Math.max(a_1, v_2);
          }
          var max_1 = maxValue_1;
          var inductionVariable_3 = 0;
          var last_3 = this.edk_1;
          if (inductionVariable_3 < last_3)
            do {
              var i = inductionVariable_3;
              inductionVariable_3 = inductionVariable_3 + 1 | 0;
              var tmp6_safe_receiver = cells_1.q1(i);
              if (tmp6_safe_receiver == null)
                null;
              else {
                tmp6_safe_receiver.vdg(cellOffsets.q1(i), currentY, cellOffsets.q1(i) + cellSize, currentY + max_1);
              }
            }
             while (inductionVariable_3 < last_3);
          currentY = currentY + (max_1 + gap);
          currentIndex_1 = currentIndex_1 + this.edk_1 | 0;
        }
        currentY = anchorRowY - gap;
        currentIndex_1 = anchorRowIndex - this.edk_1 | 0;
        while (currentY > overdraw.kd0_1 && ((currentIndex_1 + this.edk_1 | 0) - 1 | 0) >= dataRange.i2_1) {
          // Inline function 'kotlin.collections.map' call
          var this_4 = until(0, this.edk_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_3 = ArrayList().u(collectionSizeOrDefault(this_4, 10));
          var inductionVariable_4 = this_4.i2_1;
          var last_4 = this_4.j2_1;
          if (inductionVariable_4 <= last_4)
            do {
              var item_3 = inductionVariable_4;
              inductionVariable_4 = inductionVariable_4 + 1 | 0;
              var it_6 = item_3;
              var tmp_14;
              var containsLower_2 = dataRange.i2_1;
              var containsUpper_2 = dataRange.j2_1;
              var containsArg_2 = currentIndex_1 + it_6 | 0;
              if (containsLower_2 <= containsArg_2 ? containsArg_2 <= containsUpper_2 : false) {
                tmp_14 = getNewCell(currentIndex_1 + it_6 | 0, constrain);
              } else {
                tmp_14 = null;
              }
              var tmp$ret$43 = tmp_14;
              destination_3.v(tmp$ret$43);
            }
             while (!(item_3 === last_4));
          var cells_2 = destination_3;
          // Inline function 'kotlin.collections.maxOf' call
          var iterator_3 = cells_2.m1();
          if (!iterator_3.n1())
            throw NoSuchElementException().y1();
          var tmp0_safe_receiver_8 = iterator_3.o1();
          var tmp1_elvis_lhs_6 = tmp0_safe_receiver_8 == null ? null : this.jdk(tmp0_safe_receiver_8, cellSize);
          var maxValue_2 = tmp1_elvis_lhs_6 == null ? 0.0 : tmp1_elvis_lhs_6;
          while (iterator_3.n1()) {
            var tmp0_safe_receiver_9 = iterator_3.o1();
            var tmp1_elvis_lhs_7 = tmp0_safe_receiver_9 == null ? null : this.jdk(tmp0_safe_receiver_9, cellSize);
            var v_3 = tmp1_elvis_lhs_7 == null ? 0.0 : tmp1_elvis_lhs_7;
            // Inline function 'kotlin.comparisons.maxOf' call
            var a_2 = maxValue_2;
            maxValue_2 = Math.max(a_2, v_3);
          }
          var max_2 = maxValue_2;
          var inductionVariable_5 = 0;
          var last_5 = this.edk_1;
          if (inductionVariable_5 < last_5)
            do {
              var i_0 = inductionVariable_5;
              inductionVariable_5 = inductionVariable_5 + 1 | 0;
              var tmp7_safe_receiver = cells_2.q1(i_0);
              if (tmp7_safe_receiver == null)
                null;
              else {
                tmp7_safe_receiver.vdg(cellOffsets.q1(i_0), currentY - max_2, cellOffsets.q1(i_0) + cellSize, currentY);
              }
            }
             while (inductionVariable_5 < last_5);
          currentY = currentY - (max_2 + gap);
          currentIndex_1 = currentIndex_1 - this.edk_1 | 0;
        }
      }
    }
    initMetadataForClass($, 'RecyclerViewPlacerVerticalGrid');
    RecyclerViewPlacerVerticalGridClass = $;
  }
  return RecyclerViewPlacerVerticalGridClass;
}
//region block: exports
export {
  RecyclerViewPlacerVerticalGrid as RecyclerViewPlacerVerticalGrid1jojlivaz3vdj,
};
//endregion

//# sourceMappingURL=RecyclerViewPlacerVerticalGrid.mjs.map
